import React from 'react'

interface SessionDismissibleProps {
    storageKey: string
    children: JSX.Element
}

/**
 *
 */
const SessionDismissible = ({
    storageKey,
    children
}: SessionDismissibleProps) => {
    const dismiss = () => {
        sessionStorage.setItem(storageKey, 'true')
    }

    const wasDismissed = sessionStorage.getItem(storageKey) === 'true'

    if (wasDismissed) return null

    return React.cloneElement(children, {
        onSessionDismiss: dismiss
    })
}

export default SessionDismissible
